import React from 'react';
import {Link} from 'react-router';
import {Dialog} from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {header} from "constants/table";
import {ListHistoryRowItem, ListHistoryDetailRowItem} from 'modules/giai-quyet-don/datatable/rowItem';
import { Letter } from 'api';
import {isEmpty, get} from 'lodash';

class HistoryDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      DataLichSuQuaTrinhXuLy: [],
      showDetail: false,
      itemSelected: {listThongTinThayDoi: []},
      isVanBan: false
    }
  }

  componentDidMount() {
    if (this.props.type === 'ke-hoach') {
      this.getLichSuKeHoach();
    } else {
      this.getQuyTrinhXuLyHistory();
    }
  }

  getLichSuKeHoach() {
    Letter.actions.getLichSuKeHoach.request({ id: this.props.donId }).then(res => {
      if (!isEmpty(res.data._embedded)) {
        const data = get(res, "data._embedded.lichSuThayDois");
        this.setState({DataLichSuQuaTrinhXuLy: data});
      } else {
        this.setState({DataLichSuQuaTrinhXuLy: []});
      }
    });
  }

  getQuyTrinhXuLyHistory() {
    Letter.actions.getLichSuDon.request({ id: this.props.donId }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuThayDois});
      } else {
        this.setState({DataLichSuQuaTrinhXuLy: []});
      }
    });
  }

  toggleDialog() {
    this.setState({ isOpen: !this.state.isOpen, showDetail: false });
  }
  handleBack() {
    this.setState({showDetail: false});
  }
  handleViewDetail(item) {
    let isVanBan = false;
    if (item.noiDung === "Văn bản điều chỉnh") {
      isVanBan = true;
    }
    this.setState({
      itemSelected: item,
      showDetail: true,
      isVanBan
    });
  }

  render() {
    return (
      <div className="wrap-history">
        <Link className="itt-history" onClick={this.toggleDialog.bind(this)}>{this.props.title || "Lịch sử xử lý"}</Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.toggleDialog.bind(this)}
          title={this.props.title || "Lịch sử xử lý"}
          className="dialog-history wrap-block panel-popup"
          >
          <div className="body-dialog-gh">
            {
              this.state.showDetail ?
                <div className="back-foward pl25 mb0">
                  <Link onClick={this.handleBack.bind(this)}>Về trang trước</Link>
                </div>
              :''
            }
            {
              !this.state.showDetail ?
                <div className="row pl20 pr20">
                  <DataTable
                    header = {header.dialogHistory}
                    dataList={this.state.DataLichSuQuaTrinhXuLy}
                    hidePagination={true}
                    ma = {this.props.ma}
                  >
                    <ListHistoryRowItem handleViewDetail={this.handleViewDetail.bind(this)}/>
                  </DataTable>
                </div>
              :
                <div className="row pl20 pr20">
                  <DataTable
                    header = {header.dialogHistoryDetail}
                    dataList={this.state.itemSelected.listThongTinThayDoi}
                    hidePagination={true}
                  >
                    <ListHistoryDetailRowItem isVanBan={this.state.isVanBan}/>
                  </DataTable>
                </div>
            }
            <div className="box-bottom col-100 mt5">
              <Link className="btn-action btn-close action-todo" onClick={this.toggleDialog.bind(this)}><span>Đóng</span></Link>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default HistoryDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/HistoryDialog.jsx